export const GET_PROFILE_DATA = "GET_PROFILE_DATA";
export const TOGGLE_SIDE_MENU = "TOGGLE_SIDE_MENU";

export const _addUserProfileData = (data) => {
  return (dispatch) => {
    dispatch({
      type: GET_PROFILE_DATA,
      payload: data,
    });
  };
};
export const _toggleSideMenu = (isToogle) => {
  return (dispatch) => {
    dispatch({
      type: TOGGLE_SIDE_MENU,
      payload: isToogle,
    });
  };
};
